package chand.wordvoyage.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import chand.wordvoyage.data.DetailInfo
import chand.wordvoyage.repository.FirestoreRepository
import chand.wordvoyage.repository.OpenAIRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class DetailInfoState {
    object Idle : DetailInfoState()
    object Loading : DetailInfoState()
    data class Success(val detailInfo: DetailInfo) : DetailInfoState()
    data class Error(val message: String) : DetailInfoState()
}

sealed class SaveState {
    object Idle : SaveState()
    object Saving : SaveState()
    object Saved : SaveState()
    data class Error(val message: String) : SaveState()
}

class WordDetailViewModel(
    private val repository: OpenAIRepository,
    private val firestoreRepository: FirestoreRepository,
    private val userId: String
) : ViewModel() {

    private val _detailInfoState = MutableStateFlow<DetailInfoState>(DetailInfoState.Idle)
    val detailInfoState: StateFlow<DetailInfoState> = _detailInfoState.asStateFlow()

    private val _saveState = MutableStateFlow<SaveState>(SaveState.Idle)
    val saveState: StateFlow<SaveState> = _saveState.asStateFlow()

    private var currentWord: String? = null

    fun fetchDetailInfo(word: String) {
        if (word == currentWord && _detailInfoState.value !is DetailInfoState.Idle) return
        currentWord = word

        viewModelScope.launch {
            _detailInfoState.value = DetailInfoState.Loading

            repository.getWordDetailInfo(word)
                .onSuccess { detailInfo ->
                    _detailInfoState.value = DetailInfoState.Success(detailInfo)
                    // Auto-save to Firestore when details are successfully fetched
                    saveToFirestore(word, detailInfo)
                }
                .onFailure { exception ->
                    _detailInfoState.value = DetailInfoState.Error(
                        exception.message ?: "Failed to retrieve word details"
                    )
                }
        }
    }

    private fun saveToFirestore(word: String, detailInfo: DetailInfo) {
        viewModelScope.launch {
            _saveState.value = SaveState.Saving
            firestoreRepository.saveWordEntry(userId, word, detailInfo)
                .onSuccess {
                    _saveState.value = SaveState.Saved
                    println("Word '$word' saved to Firestore successfully")
                }
                .onFailure { e ->
                    _saveState.value = SaveState.Error(e.message ?: "Failed to save")
                    println("Failed to save word '$word': ${e.message}")
                }
        }
    }

    fun clearDetailInfo() {
        _detailInfoState.value = DetailInfoState.Idle
        _saveState.value = SaveState.Idle
    }

    override fun onCleared() {
        super.onCleared()
        repository.close()
    }
}



